export default {"src":"/_next/static/media/logicmonitor.37a4bf47.svg","height":34,"width":190,"blurWidth":0,"blurHeight":0};